import { useEffect, useState, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/sections/Hero";
import { Stats } from "@/components/sections/Stats";
import { Manifesto } from "@/components/sections/Manifesto";
import { Modules } from "@/components/sections/Modules";
import { EditorialMarquee } from "@/components/sections/Marquee";
import { Services } from "@/components/sections/Services";
import { ARAudit } from "@/components/sections/ARAudit";
import { Testimonials } from "@/components/sections/Testimonials";
import { Pricing } from "@/components/sections/Pricing";
import { BookMeeting } from "@/components/sections/BookMeeting";
import { Contact } from "@/components/sections/Contact";

export default function Landing() {
  const [plan, setPlan] = useState(null);
  const [showTop, setShowTop] = useState(false);
  const contactRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleSelect = (name) => {
    setPlan(name);
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-white min-h-screen" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Stats />
      <Modules />
      <EditorialMarquee />
      <Manifesto />
      <Pricing onSelect={handleSelect} />
      <Testimonials />
      <Services onSelect={handleSelect} />
      <ARAudit />
      <Contact ref={contactRef} plan={plan} />
      <BookMeeting />
      <Footer />
      <AnimatePresence>
        {showTop && (
          <motion.button
            type="button"
            data-testid="scroll-to-top"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 12 }}
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-[#2880B8] text-white shadow-[0_16px_36px_-16px_rgba(40,128,184,0.75)] transition-colors hover:bg-[#1F6EA1]"
            aria-label="Scroll to top"
          >
            <ArrowUp size={20} />
          </motion.button>
        )}
      </AnimatePresence>
    </div>
  );
}
